import { render } from "./PaginationLoader.vue?vue&type=template&id=72353795&scoped=true"
import script from "./PaginationLoader.vue?vue&type=script&lang=js"
export * from "./PaginationLoader.vue?vue&type=script&lang=js"

import "./PaginationLoader.vue?vue&type=style&index=0&id=72353795&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72353795"]])

export default __exports__